<p *ngIf="showTitle" class="legend-title">{{ 'Legend' | translate }}</p>
<!--REDDI Report Legend-->
<div class="legend-report" *ngIf="showReportLegend">
  <div class="legend-page-column">
    <table class="legend-table">
      <tr>
        <td>
          <span class="legend-color-1">xxx</span>
          <span class="legend-color-2">xxx</span>
          <span class="legend-color-white">xxx</span>
        </td>
        <td class="legend-text-style">
          {{ 'No response' | translate }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="legend-color-3">xxx</span>
          <span class="legend-color-4">xxx</span>
          <span class="legend-color-white">xxx</span>
        </td>
        <td class="legend-text-style">
          {{ 'Auditory cues present' | translate }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="legend-color-5">xxx</span>
          <span class="legend-color-6">xxx</span>
          <span class="legend-color-7">xxx</span>
        </td>
        <td class="legend-text-style">
          {{ 'Response with no auditory' | translate }}
        </td>
      </tr>
    </table>
  </div>
  <div class="legend-page-column">
    <div class="legend-col-padding">
      <span class="legend-box">*</span>
      <span class="legend-text-font">
        {{ 'Detection Response' | translate }}</span
      >
    </div>
    <div>
      <span class="legend-box"><span class="legend-star-color">*</span></span>
      <span class="legend-text-font">
        {{ 'Imitation Response' | translate }}</span
      >
    </div>
  </div>
</div>
<!--REDDI Assessment Instance Legend-->
<div class="legend-assessment" *ngIf="!showReportLegend">
  <div class="legend-page-row">
    <table class="legend-table-assessment">
      <tr>
        <td class="legend-table-width">
          <span
            class="material-symbols-outlined reddi-response-icon-positive"
            [style.font-size.px]="_size"
            >{{ _icon_detection }}</span
          >
          <span class="legend-text-alignment">
            {{ 'Detected' | translate }}</span
          >
        </td>
        <td class="legend-table-width">
          <span
            class="material-symbols-outlined reddi-response-icon-positive rotate-ninety-degrees"
            [style.font-size.px]="_size"
            >{{ _icon_imitation }}</span
          >
          <span class="legend-text-alignment">
            {{ 'Correct imitation' | translate }}</span
          >
        </td>
      </tr>
      <tr>
        <td>
          <span
            class="material-symbols-outlined reddi-response-icon-negative"
            [style.font-size.px]="_size"
            >{{ _icon_detection }}</span
          >
          <span class="legend-text-alignment">
            {{ 'Not detected' | translate }}</span
          >
        </td>
        <td>
          <span
            class="material-symbols-outlined reddi-response-icon-negative rotate-ninety-degrees"
            [style.font-size.px]="_size"
            >{{ _icon_imitation }}</span
          >
          <span class="legend-text-alignment">
            {{ 'Incorrect imitation' | translate }}</span
          >
        </td>
      </tr>
    </table>
    <div class="legend-er-text">
      <div>
        <span class="material-symbols-outlined" [style.font-size.px]="30">{{
          _icon_hand
        }}</span>
      </div>
      <div class="legend-page-column">
        <span>{{ 'Hover over' | translate }} ,</span>
        <span> {{ 'sound the child produced' | translate }} </span>
      </div>
    </div>
  </div>
</div>
